<template>
  <div v-if="$isFeatureEnabled($featureFlags.site_report_migration)">
    <q-btn
      flat
      dense
      round
      size="sm"
      @click="$emit('edit', true)"
    >
      <q-tooltip
        anchor="top middle"
        self="bottom middle"
      >
        This report element is outdated. Click to edit report.
      </q-tooltip>
      <q-icon
        class="col-auto"
        :size="size"
        name="error"
        color="black"
      />
    </q-btn>
  </div>
</template>

<script>

export default {
  name: 'ReportMigratableButton',
  props: {
    size: {
      type: String,
      required: false,
      default: 'md'
    }
  },
  emits: ['edit'],
  data () {
  }
}
</script>
<style lang="scss" scoped>
</style>
